import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { CardLayout, TableLayout } from '../containers/Layout';

import { fetchProducts } from '../../../../../../../jsx/actions/productAction';
import { isEmpty } from "lodash";
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, TableHead, TableBody, TableFooter, Box } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';
import PopUp from '../../../../commonModules/interface/PopUp';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleSalePopUp extends Component {
    state = { 
        sale: {}
    }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING SALE SINGLE POP UP");
        console.log("[SingleSalePopUp] Initial PRODUCTS:", this.props.PRODUCTS);
        this.getSaleById()
        
        // Always try to fetch products if empty
        if (isEmpty(this.props.PRODUCTS)){
            console.log("[SingleSalePopUp] PRODUCTS empty, fetching...");
            this.props.fetchProducts()
        } else {
            console.log("[SingleSalePopUp] PRODUCTS already loaded, count:", Object.keys(this.props.PRODUCTS || {}).length);
        }
      
    }

    componentDidUpdate = (prevProps) => {
        // If products were just loaded, component will re-render automatically
        if (isEmpty(prevProps.PRODUCTS) && !isEmpty(this.props.PRODUCTS)) {
            console.log("[SingleSalePopUp] PRODUCTS loaded! Count:", Object.keys(this.props.PRODUCTS).length);
            // Force re-render to show product names
            this.forceUpdate();
        }
        
        // If sale data is loaded but products are still empty, try fetching again
        if (this.state.sale.id && isEmpty(this.props.PRODUCTS) && !this._fetchingProducts) {
            this._fetchingProducts = true;
            console.log("[SingleSalePopUp] Sale loaded but PRODUCTS empty, fetching products...");
            this.props.fetchProducts();
            // Reset flag after a delay
            setTimeout(() => {
                this._fetchingProducts = false;
            }, 5000);
        }
    }
    getSaleById = async () => {
        try {
            console.log("[SingleSalePopUp] getSaleById called with saleID (should be transfer_id):", this.props.saleID);
            const requestBody = {
                page:"sales",
                id: this.props.saleID
            };
            console.log("[SingleSalePopUp] Request body:", JSON.stringify(requestBody));
            
            const req = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(requestBody),
                credentials: 'same-origin',
            }); 
            
            const sale = await req.json()
            console.log("[SingleSalePopUp] Response received:", sale)

            if(!sale.error && sale.id){ // no errors
                // Ensure date field exists for SingleTemplate (uses creation_date if date doesn't exist)
                if (!sale.date && sale.creation_date) {
                    sale.date = sale.creation_date;
                }
                
               this.setState({sale})
            
            } else {
                
                console.log('====================================');
                console.log("ERROR getSaleById", sale);
                console.log('====================================');
            }
            
        } catch (err) {
           console.log('====================================');
           console.log("ERROR getSaleById", err);
           console.log('====================================');
        }
    }

    createProductList = () => {
        const { PRODUCTS } = this.props
        const { sale } = this.state;

        console.log({sale});
        console.log("[createProductList] PRODUCTS keys:", PRODUCTS ? Object.keys(PRODUCTS).slice(0, 5) : 'N/A');
        
        if (!sale.products || !Array.isArray(sale.products)) {
            return null;
        }

        return sale.products.map( saleItem => {
            // Try to find product by product_id first (most common case)
            let prod = PRODUCTS && PRODUCTS[saleItem.product_id];
            
            // If not found, try to find by searching through all products
            if (!prod && PRODUCTS) {
                const productValues = Object.values(PRODUCTS);
                prod = productValues.find(p => p.id === saleItem.product_id || p.product_id === saleItem.product_id);
            }
            
            console.log(`[createProductList] saleItem.product_id: ${saleItem.product_id}, found:`, !!prod);
            
            // Use values directly from backend (similar to SingleTransferSale)
            let totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }
            
            return (
                <TableRow key={saleItem.id}>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${saleItem.product_id}`}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    <TableCell>{formatNumbers.format(totalTTC)}</TableCell>
                </TableRow>
            )
        })
    }
    getTotal = () => {
        let total = 0
        const { sale } = this.state
        
        if (!sale.products || !Array.isArray(sale.products)) {
            return [formatNumbers.format(0)];
        }
        
        sale.products.map( saleItem => {
            // Use values directly from backend (similar to SingleTransferSale)
            let totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || 0);
            let totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || 0);
            let tvaRate = saleItem.tva_rate || 0;
            
            // Only recalculate if tvaRate > 0 AND totalTTC equals totalHT (incorrect data)
            if (tvaRate !== 0 && totalTTC === totalHT) {
                totalTTC = totalHT * (1 + tvaRate / 100);
            }
            
            total += totalTTC
        })
        
        return [
            formatNumbers.format(total), 
        ]
    }

    render(){
        console.log("[STATE] ",this.state);
        console.log("[PROPS] PRODUCTS:", this.props.PRODUCTS);
        console.log("[PROPS] PRODUCTS type:", typeof this.props.PRODUCTS);
        console.log("[PROPS] PRODUCTS isEmpty:", isEmpty(this.props.PRODUCTS));
        console.log("[PROPS] PRODUCTS keys:", this.props.PRODUCTS ? Object.keys(this.props.PRODUCTS).length : 'N/A');
        
        const { sale } = this.state;
        const { PRODUCTS } = this.props;
        
        // Check if sale has required data
        const hasSaleData = sale && sale.id && sale.products && Array.isArray(sale.products) && sale.products.length > 0;
        const hasProducts = PRODUCTS && !isEmpty(PRODUCTS);
        
        console.log("[RENDER] hasSaleData:", hasSaleData);
        console.log("[RENDER] hasProducts:", hasProducts);
        
        // Allow rendering even if products are not loaded yet (will show product IDs)
        const canRender = hasSaleData;
        // Show products table even if PRODUCTS not loaded - we have fallback to show IDs
        // Only show loading spinner for a short time, then show table anyway
        const isLoadingProducts = false; // Always show table, products will load asynchronously
        
        return(
            <PopUp 
                maxWidth="md"
                close={this.props.closeSale} title={sale.id ? `Vente n° ${sale.id}` : 'Vente'}
            >
                {canRender &&
                    <SingleTemplate
                        sale={sale}
                        shopID={sale.shop_id}
                        notif={this.props.notif}
                    >
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Produit</TableCell>
                                    <TableCell>Quantité</TableCell>
                                    <TableCell>Prix</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.createProductList()}
                                <TableRow>
                                    <TableCell colSpan={3}></TableCell>
                                </TableRow>
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>TOTAL</TableCell>
                                    <TableCell>
                                        {this.getTotal()}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                                
                        </TableLayout>
                    </SingleTemplate>
                }
                {!canRender &&
                    <Spin noOverlay />
                }
                    
            </PopUp>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchProducts,
    
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleSalePopUp);
